import React from 'react';
import { 
  Activity, PieChart as PieChartIcon, School, Scale, Compass, 
  Zap, List, AlertTriangle, Target, Users, ShieldCheck, 
  BrainCircuit, HeartPulse, CheckCircle, Download, Loader2, Sparkles, Brain
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const BasarisizlikReportUI = ({ data, meta }) => {
  const risks = data.risks || [];

  // AKILLI KATEGORİ TAHMİN MOTORU
  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/aile|anne|baba|ev|kardeş|maddi|baskı/)) return "Aile ve Çevre Faktörü";
    if (lower.match(/okul|öğretmen|arkadaş|sınıf|gürültü/)) return "Okul ve Eğitim Ortamı";
    if (lower.match(/plan|zaman|hedef|istek|üşen|çalışm|tekrar/)) return "Çalışma Alışkanlıkları ve Motivasyon";
    if (lower.match(/kaygı|heyecan|unut|dikkat|sınav|korku/)) return "Bilişsel Faktörler ve Sınav Kaygısı";
    return "Genel Akademik Nedenler";
  };

  const categories = {};
  const allRisksFormatted = [];
  
  // Analiz Sayaçları
  let internalCount = 0; 
  let externalCount = 0; 
  let effortCount = 0;   
  let strategyCount = 0; 

  risks.forEach((r, i) => {
    const text = typeof r === 'object' ? r.text : r;
    let category = typeof r === 'object' && r.category ? r.category : "";
    
    if (!category || category.includes("Baskın Neden") || category === "Genel") {
        category = guessCategory(text);
    }

    const id = typeof r === 'object' ? r.id : (i + 1);
    // 🔥 KESİN TEMİZLİK: Üçgeni ve her türlü parantezli KRİTİK yazısını uçur
    // 🔥 KESİN TEMİZLİK: KRİTİK yazısını ve cümlenin başındaki üçgen, parantez gibi tüm yabancı sembolleri kazır
const cleanText = text
    .replace(/[\[\(]?KRİTİK[\]\)]?/gi, "") 
    .replace(/^[^a-zA-ZçÇğĞıİöÖşŞüÜ0-9]+/, "") 
    .trim();

    if (!categories[category]) categories[category] = 0;
    categories[category]++;

    allRisksFormatted.push({ id, text: cleanText, category });

    // KONTROL ODAĞI ANALİZİ
    const lower = cleanText.toLowerCase();
    if (lower.match(/kendim|çalışmı|anlamı|heyecan|unut|plan|dikkat|hedef|istek|üşen|zamanımı|kaygı/)) {
        internalCount++;
    } else if (lower.match(/öğretmen|aile|arkadaş|ortam|gürültü|zor|sınav|zaman yetm|okul|sınıf/)) {
        externalCount++;
    } else {
        internalCount += 0.5; externalCount += 0.5; 
    }

    // ÇABA vs STRATEJİ ANALİZİ
    if (lower.match(/istek|sıkıcı|hedef|üşen|çalışmak gelmi|motivasyon|ilgi/)) {
        effortCount++;
    } else if (lower.match(/anlamı|unut|plan|yöntem|nasıl|temel|dikkat|kaygı|heyecan|test/)) {
        strategyCount++;
    }
  });

  const sortedCats = Object.entries(categories).sort((a, b) => b[1] - a[1]);
  const maxCategoryCount = sortedCats.length > 0 ? sortedCats[0][1] : 1;

  // --- KART 1: KONTROL ODAĞI HESAPLAMASI ---
  const totalLocus = internalCount + externalCount || 1;
  const internalPercent = Math.round((internalCount / totalLocus) * 100);
  const externalPercent = 100 - internalPercent;
  
  let locusText = "";
  if (internalPercent > 65) {
      locusText = "Öğrenci başarısızlığın faturasını kendine kesiyor. Yoğun bir içsel suçluluk, özgüven kırıklığı veya yetersizlik hissi taşıyor olabilir.";
  } else if (externalPercent > 65) {
      locusText = "Öğrenci başarısızlığı dış faktörlere (okul, aile, çevre) atfetme eğiliminde. Sorumluluk almaktan kaçınıyor veya kurban psikolojisi yaşıyor olabilir.";
  } else {
      locusText = "Öğrenci başarısızlığın sorumluluğunu içsel ve dışsal nedenler arasında dengeli bir şekilde dağıtmaktadır. Gerçekçi bir farkındalığı olabilir.";
  }

  // --- KART 2: ÇABA vs STRATEJİ MATRİSİ ---
  let strategyText = "Veriler yetersiz.";
  let strategyIconCol = "text-slate-600";
  let strategyBg = "bg-slate-50";
  let strategyBorder = "border-slate-200";

  if (effortCount > strategyCount && effortCount > 0) {
      strategyText = "Teşhis: DÜŞÜK ÇABA / MOTİVASYON. Öğrencinin temel sorunu 'nasıl çalışacağını bilmemek' değil, masaya oturma direncidir. Hedefsizlik ve isteksizlik üzerine çalışılmalıdır.";
      strategyIconCol = "text-orange-600"; strategyBg = "bg-orange-50"; strategyBorder = "border-orange-200";
  } else if (strategyCount > effortCount && strategyCount > 0) {
      strategyText = "Teşhis: YANLIŞ STRATEJİ / BECERİ EKSİKLİĞİ. Öğrencinin çabalama isteği var ancak yanlış çalışma taktikleri veya temel eksikliği nedeniyle emeğinin karşılığını alamıyor.";
      strategyIconCol = "text-indigo-600"; strategyBg = "bg-indigo-50"; strategyBorder = "border-indigo-200";
  } else if (effortCount === strategyCount && effortCount > 0) {
      strategyText = "Teşhis: KARMAŞIK TIKANIKLIK. Öğrenci hem motivasyon eksikliği yaşıyor hem de doğru çalışma stratejilerini bilmiyor. Kapsamlı bir akademik yapılandırma sürecine ihtiyaç vardır.";
      strategyIconCol = "text-sky-600"; strategyBg = "bg-sky-50"; strategyBorder = "border-sky-200";
  }

  // --- KART 3: HIZLI KAZANIM (QUICK WIN) HAVUZU ---
  const quickWinPool = [
      "Öğrenciye dağ gibi biriken tüm konuları toparlama planı yapmak yerine, bu hafta sadece en iyi olduğu (veya en sevdiği) 1 dersten çok kolay bir görev verin. Amacımız 'başarabildiğini' hissetmesi.",
      "Çalışma saatlerini değil, masaya oturma alışkanlığını hedefleyin. 'Bu hafta günde sadece 15 dakika test çözmeni istiyorum, doğrular önemli değil, sadece o süre masada kal' diyerek direnci kırın.",
      "Öğrenciyle hedeflerini konuşmak yerine, bu hafta sadece 'zaman hırsızlarını' tespit etme görevi verin. 'Bana 3 gün boyunca telefonun ekran süresini not alıp getirir misin?' deyin."
  ];
  const studentSeed = risks.length + (meta?.studentNo ? String(meta.studentNo).charCodeAt(0) : 0);
  const microActionText = quickWinPool[studentSeed % quickWinPool.length];

  const getCategoryColor = (index) => {
    const colors = ['bg-indigo-600', 'bg-purple-500', 'bg-blue-400', 'bg-teal-500', 'bg-slate-400'];
    return colors[index % colors.length];
  };

  const isHighVolume = allRisksFormatted.length > 14;

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      
      {/* BAŞLIK VE ÖĞRENCİ BİLGİSİ */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner bg-slate-700">
            <Activity className="h-6 w-6 print:h-4 print:w-4"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Başarısızlık Nedenleri Analizi</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl print:text-xl font-black block leading-none">{risks.length}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Madde</span>
        </div>
      </div>

      {/* SİMETRİK ÜST BÖLGE: GRAFİK VE KONTROL ODAĞI KARTI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         {/* SOL: KATEGORİ DAĞILIMI */}
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
           <h3 className="font-bold text-slate-800 mb-4 print:mb-2.5 flex items-center text-sm print:text-[11px] border-b pb-2 print:pb-1.5">
             <PieChartIcon className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-indigo-600"/> Ana Problem Alanları
           </h3>
           <div className="space-y-4 print:space-y-2 flex-1 flex flex-col justify-center">
             {sortedCats.length > 0 ? sortedCats.map(([name, count], i) => (
               <div key={name}>
                 <div className="flex justify-between items-end mb-1 print:mb-0.5">
                   <span className="text-[10px] print:text-[8px] font-bold text-slate-600 uppercase tracking-wide">{name}</span>
                   <span className="text-xs print:text-[9px] font-black text-slate-800">{count} Madde</span>
                 </div>
                 <div className="h-2 print:h-1.5 w-full bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-300">
                   <div className={`h-full rounded-full print:bg-black ${getCategoryColor(i)}`} style={{ width: `${(count / maxCategoryCount) * 100}%` }}></div>
                 </div>
               </div>
             )) : <p className="text-xs text-slate-400 italic">Veri bulunamadı.</p>}
           </div>
         </div>

         {/* SAĞ: KONTROL ODAĞI TERAZİSİ */}
         <div className="bg-blue-50 p-5 print:p-4 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-blue-200 pb-3 print:pb-2 print:border-slate-200">
             <Scale className="h-5 w-5 print:h-4 print:w-4 text-blue-600 mr-3 print:mr-2"/>
             <div>
               <span className="text-xs print:text-[10.5px] font-black text-blue-900 uppercase tracking-widest block leading-none">Kontrol Odağı (Atıf) Terazisi</span>
               <span className="text-[9px] print:text-[8px] font-medium text-blue-600 uppercase tracking-wide mt-0.5 block">Öğrenci Kimi Suçluyor?</span>
             </div>
           </div>
           
           <div className="flex items-center justify-between mb-2 mt-1">
               <div className="text-center w-16 print:w-16">
                   <span className="block text-[10px] print:text-[8px] font-bold text-slate-500 leading-tight">İÇSEL<br/>(Kendisi)</span>
                   <span className="text-lg print:text-sm font-black text-indigo-600">%{internalPercent}</span>
               </div>
               <div className="flex-1 px-4 print:px-3 flex items-center">
                   <div className="h-2 print:h-1.5 flex-1 bg-indigo-500 rounded-l-full print:bg-slate-700 opacity-90"></div>
                   <div className="h-2 print:h-1.5 flex-1 bg-rose-400 rounded-r-full print:bg-slate-300 opacity-90"></div>
               </div>
               <div className="text-center w-16 print:w-16">
                   <span className="block text-[10px] print:text-[8px] font-bold text-slate-500 leading-tight">DIŞSAL<br/>(Çevre)</span>
                   <span className="text-lg print:text-sm font-black text-rose-500">%{externalPercent}</span>
               </div>
           </div>
           
           <p className="text-[11px] print:text-[10px] text-slate-700 leading-snug font-medium mt-2 text-justify">
             {locusText}
           </p>
         </div>
      </div>

      {/* ORTA BÖLGE YAN YANA ALINDI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         
         {/* ÇABA VS STRATEJİ MATRİSİ */}
         <div className={`${strategyBg} p-5 print:p-4 rounded-2xl border ${strategyBorder} shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300`}>
           <div className="flex items-center mb-1">
             <Compass className={`h-5 w-5 print:h-4 print:w-4 ${strategyIconCol} mr-2`}/>
             <span className={`text-xs print:text-[10px] font-black uppercase tracking-widest ${strategyIconCol}`}>Kör Nokta Radarı</span>
           </div>
           <h4 className={`text-sm print:text-[11.5px] font-black mb-1.5 mt-1 ${strategyIconCol}`}>Çaba vs. Strateji Analizi</h4>
           <p className="text-[13px] print:text-[9.5px] font-medium text-slate-700 leading-snug text-justify">
             {strategyText}
           </p>
         </div>

         {/* HIZLI KAZANIM (QUICK WIN) AKSİYONU */}
         <div className="bg-emerald-50 p-5 print:p-4 rounded-2xl border border-emerald-100 shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300">
           <div className="flex items-center mb-1">
             <Zap className="h-5 w-5 print:h-4 print:w-4 text-emerald-600 mr-2"/>
             <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-emerald-900">Hızlı Kazanım (İlk 1 Hafta)</span>
           </div>
           <h4 className="text-sm print:text-[11.5px] font-black text-emerald-800 mb-1.5 mt-1">Acil Aksiyon Adımı</h4>
           <p className="text-[13px] print:text-[9.5px] font-medium text-emerald-900 leading-snug text-justify">
             {microActionText}
           </p>
         </div>
      </div>

      {/* ALT BÖLGE: TAM GENİŞLİKTE LİSTE */}
      <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1 mt-2">
        <h3 className="font-bold text-slate-800 mb-4 print:mb-3 flex items-center text-sm print:text-[11px] border-b pb-3 print:pb-2">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Tüm İşaretlenen Nedenler ({allRisksFormatted.length})
        </h3>
        
        {allRisksFormatted.length > 0 ? (
          <div className={`grid grid-cols-1 md:grid-cols-2 ${isHighVolume ? 'print:grid-cols-3 print:gap-1.5' : 'print:grid-cols-2 print:gap-2.5'} gap-3`}>
            {allRisksFormatted.map((item, i) => (
              <div key={i} className={`flex items-start p-3 ${isHighVolume ? 'print:p-1.5' : 'print:p-2'} bg-white border border-slate-200 rounded-xl print:rounded-lg shadow-sm hover:border-indigo-200 transition-colors`}>
                <div className={`min-w-[24px] h-6 ${isHighVolume ? 'print:min-w-[14px] print:h-3.5 print:text-[7px]' : 'print:min-w-[18px] print:h-4.5 print:text-[8px]'} rounded flex items-center justify-center text-[10px] font-black mr-3 ${isHighVolume ? 'print:mr-1.5' : 'print:mr-2'} border bg-slate-100 text-slate-600 border-slate-200`}>
                  {item.id}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1 print:mb-[1px]">
                    <span className={`block text-[8px] ${isHighVolume ? 'print:text-[6.5px]' : 'print:text-[7.5px]'} font-bold text-slate-400 uppercase tracking-wider`}>{item.category}</span>
                  </div>
                  <span className={`text-[11px] ${isHighVolume ? 'print:text-[8px] leading-tight' : 'print:text-[9.5px] leading-snug'} text-slate-800 font-medium block`}>{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-slate-400 italic text-center py-4 print:py-2">İşaretlenmiş madde bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateBasarisizlik = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const guessCategory = (text) => {
    const lower = text.toLowerCase();
    if (lower.match(/aile|anne|baba|ev|kardeş|maddi|baskı/)) return "Aile ve Çevre Faktörü";
    if (lower.match(/okul|öğretmen|arkadaş|sınıf|gürültü/)) return "Okul ve Eğitim Ortamı";
    if (lower.match(/plan|zaman|hedef|istek|üşen|çalışm|tekrar/)) return "Çalışma Alışkanlıkları ve Motivasyon";
    if (lower.match(/kaygı|heyecan|unut|dikkat|sınav|korku/)) return "Bilişsel Faktörler ve Sınav Kaygısı";
    return "Genel Akademik Nedenler";
  };

  let redAlarmStudents = 0;
  let totalRisksCount = 0;
  let internalCount = 0; 
  let externalCount = 0; 

  const categoryMap = {};
  const classMap = {};
  const itemMap = {}; 

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, riskCount: 0 };
    }
    classMap[className].studentCount++;

    const risks = s.reportData?.risks || [];
    totalRisksCount += risks.length;
    classMap[className].riskCount += risks.length;

    if (s.reportData?.summary?.includes("KIRMIZI") || s.reportData?.summary?.includes("YÜKSEK") || risks.length > 8) {
        redAlarmStudents++;
    }

    risks.forEach(r => {
      const text = typeof r === 'object' ? r.text : r;
      // 🔥 KESİN TEMİZLİK: Kurumsal analizde de metinleri pırıl pırıl yap
      // 🔥 KESİN TEMİZLİK: KRİTİK yazısını ve cümlenin başındaki üçgen, parantez gibi tüm yabancı sembolleri kazır
const cleanText = text
    .replace(/[\[\(]?KRİTİK[\]\)]?/gi, "") 
    .replace(/^[^a-zA-ZçÇğĞıİöÖşŞüÜ0-9]+/, "") 
    .trim();
      let cat = typeof r === 'object' && r.category ? r.category : "";
      
      if (!cat || cat.includes("Baskın Neden") || cat === "Genel") {
          cat = guessCategory(cleanText);
      }

      if (!categoryMap[cat]) categoryMap[cat] = 0;
      categoryMap[cat]++;

      const id = typeof r === 'object' ? r.id : cleanText;
      if (!itemMap[id]) itemMap[id] = { id, text: cleanText, count: 0, category: cat };
      itemMap[id].count++;

      const lower = cleanText.toLowerCase();
      if (lower.match(/kendim|çalışmı|anlamı|heyecan|unut|plan|dikkat|hedef|istek|üşen|zamanımı|kaygı/)) {
          internalCount++;
      } else if (lower.match(/öğretmen|aile|arkadaş|ortam|gürültü|zor|sınav|zaman yetm|okul|sınıf/)) {
          externalCount++;
      } else {
          internalCount += 0.5; externalCount += 0.5; 
      }
    });
  });

  const avgRisksPerStudent = total > 0 ? (totalRisksCount / total).toFixed(1) : 0;
  const totalLocus = internalCount + externalCount || 1;
  const internalPercent = Math.round((internalCount / totalLocus) * 100);
  const externalPercent = 100 - internalPercent;

  const topCategories = Object.entries(categoryMap)
    .map(([name, count]) => ({ name, count, percent: Math.round((count / totalRisksCount) * 100) }))
    .sort((a, b) => b.count - a.count);

  const dominantCategory = topCategories.length > 0 ? topCategories[0] : { name: 'Belirsiz', percent: 0 };

  const classStats = Object.values(classMap).map(c => ({
    ...c,
    riskScore: c.studentCount > 0 ? (c.riskCount / c.studentCount).toFixed(1) : 0
  })).sort((a, b) => b.riskScore - a.riskScore);

  const top10Items = Object.values(itemMap)
    .map(i => ({ ...i, percent: Math.round((i.count / total) * 100) }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);

  return { total, redAlarmStudents, avgRisksPerStudent, internalPercent, externalPercent, topCategories, dominantCategory, classStats, top10Items };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const BasarisizlikKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateBasarisizlik(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm = data.redAlarmStudents > 0;
  const redAlarmPercent = data.total > 0 ? Math.round((data.redAlarmStudents / data.total) * 100) : 0;

  // Kurumsal Kontrol Odağı Metni
  let locusText = "";
  if (data.internalPercent > 65) {
      locusText = "Kurumdaki öğrenciler başarısızlığın faturasını büyük oranda kendilerine (içsel) kesmektedir. Öğrencilerde 'yapamıyorum, kapasitem yetmiyor' inancı, özgüven kırıklığı ve öğrenilmiş çaresizlik hakim olabilir.";
  } else if (data.externalPercent > 65) {
      locusText = "Öğrenciler başarısızlığı büyük oranda dış faktörlere (sistem, öğretmen, aile, ortam) atfetmektedir. Kurumda sorumluluk almaktan kaçınma ve 'kurban psikolojisi' yaygındır.";
  } else {
      locusText = "Kurumdaki öğrenciler başarısızlığın sorumluluğunu kendi çabaları (içsel) ve çevresel faktörler (dışsal) arasında gerçekçi ve dengeli bir şekilde dağıtmaktadır.";
  }

  // Kurumsal Çaba vs Strateji Metni
  let strategyText = "Veri yetersiz.";
  let strategyIconCol = "text-slate-600";
  let strategyBg = "bg-slate-50 border-slate-200";

  if (data.effortCount > data.strategyCount && data.effortCount > 0) {
      strategyText = "Kurumdaki temel akademik sorun 'nasıl çalışılacağını bilmemek' değil, masaya oturma direncidir. Bilgi ve taktik eksikliğinden ziyade kronik bir hedefsizlik ve motivasyon kaybı yaşanmaktadır. Acilen içsel motivasyon etkinliklerine odaklanılmalıdır.";
      strategyIconCol = "text-orange-600"; 
      strategyBg = "bg-orange-50 border-orange-200";
  } else if (data.strategyCount > data.effortCount && data.strategyCount > 0) {
      strategyText = "Öğrencilerin çabalama ve çalışma isteği var ancak yanlış çalışma taktikleri, temelsizlik veya odaksızlık nedeniyle emeklerinin karşılığını alamıyorlar. Acilen 'Verimli Ders Çalışma ve Zaman Yönetimi' seminerleri ile akademik koçluk yapılmalıdır.";
      strategyIconCol = "text-indigo-600"; 
      strategyBg = "bg-indigo-50 border-indigo-200";
  }

  // GENİŞLETİLMİŞ MÜDAHALE VE PAYDAŞ EYLEM PLANI (ALT KARTLAR İÇİN)
  let interventionObj = {};
  let stakeholderObj = {};

  if (data.dominantCategory.name === "Aile ve Çevre Faktörü") {
      interventionObj = {
          title: "Sistemik Aile Müdahalesi",
          icon: Users, color: "text-rose-700", bg: "bg-rose-50 print:bg-white border-rose-200 print:border-slate-300",
          desc: "Başarısızlığın kök nedeni ağırlıklı olarak ev içi dinamikler ve ebeveyn tutumlarıdır.",
          bullets: [
              "Ebeveynlere 'Başarı Beklentisi ve Sınır Koyma' semineri planlanmalıdır.",
              "Ekonomik/ailevi kriz yaşayan öğrenciler için gizli destek mekanizmaları kurulmalıdır.",
              "Öğrencilerin okulda kalma sürelerini (etüt, kütüphane vb.) artıracak çözümler üretilmelidir."
          ]
      };
      stakeholderObj = {
          title: "Öğretmen ve Veli Yaklaşımı",
          icon: Target, color: "text-indigo-700", bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300",
          desc: "Öğrencinin evdeki dezavantajlı durumu, okulda koşulsuz kabul ile telafi edilmeye çalışılmalıdır.",
          bullets: [
              "Öğretmenler: Başarıyı değil, çabayı ve okula devamlılığı takdir eden bir dil kullanmalıdır.",
              "Veli İletişimi: Suçlayıcı değil, 'Nasıl işbirliği yapabiliriz?' odaklı görüşmeler yapılmalıdır.",
              "PDR Odak: Ev ortamı riskli öğrencilerle psikolojik sağlamlık (resilience) çalışılmalıdır."
          ]
      };
  } else if (data.dominantCategory.name === "Okul ve Eğitim Ortamı") {
      interventionObj = {
          title: "Okul İklimi ve Aidiyet",
          icon: School, color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",
          desc: "Sınıf içi gürültü, öğretmen iletişimi veya akran zorbalığı akademik başarıyı doğrudan sabote etmektedir.",
          bullets: [
              "Riskli şubelerde 'Sınıf Kuralları ve Akran Saygısı' konulu grup rehberliği yapılmalıdır.",
              "Öğrencilerin okula aidiyetini artıracak sosyal, sportif ve kültürel faaliyetler çoğaltılmalıdır.",
              "İdare ile fiziksel eğitim ortamının (ısı, gürültü, sıra) iyileştirilmesi görüşülmelidir."
          ]
      };
      stakeholderObj = {
          title: "Sınıf Yönetimi ve Güvenli Alan",
          icon: ShieldCheck, color: "text-teal-700", bg: "bg-teal-50 print:bg-white border-teal-200 print:border-slate-300",
          desc: "Sınıf, öğrenci için 'sınandığı bir mahkeme' değil, 'güvenle hata yapabildiği bir atölye' olmalıdır.",
          bullets: [
              "Öğretmenler: Derste eşit söz hakkı vermeli, etiketleyici ve kıyaslayıcı dilden kaçınmalıdır.",
              "Sınıf Rehberliği: Dışlanan veya uyum sorunu yaşayan öğrencilere kaynaştırma etkinlikleri yapılmalıdır.",
              "İdare: Disiplin sorunlarında cezalandırıcı değil, onarıcı (restoratif) yaklaşım benimsemelidir."
          ]
      };
  } else if (data.dominantCategory.name === "Bilişsel Faktörler ve Sınav Kaygısı") {
      interventionObj = {
          title: "Bilişsel Yeniden Yapılandırma",
          icon: BrainCircuit, color: "text-purple-700", bg: "bg-purple-50 print:bg-white border-purple-200 print:border-slate-300",
          desc: "Başarısızlık korkusu, unutma kaygısı ve felaket senaryoları öğrencinin potansiyelini kilitlemektedir.",
          bullets: [
              "Kurum genelinde 'Sınav Kaygısı ve Stres Yönetimi' seminerleri acilen gündeme alınmalıdır.",
              "Sınav anında kullanılabilecek topraklama (grounding) ve nefes egzersizleri öğretilmelidir.",
              "Yüksek kaygılı öğrenciler tespit edilip, bireysel danışmaya (EMDR/BDT) alınmalıdır."
          ]
      };
      stakeholderObj = {
          title: "Destekleyici Akademik Dil",
          icon: HeartPulse, color: "text-emerald-700", bg: "bg-emerald-50 print:bg-white border-emerald-200 print:border-slate-300",
          desc: "Öğrencinin kendi gözündeki değerinin, akademik notlarından ibaret olmadığı hissettirilmelidir.",
          bullets: [
              "Öğretmenler: Sınavları bir 'sonuç' değil, öğrenme sürecinin bir 'kontrol noktası' olarak sunmalıdır.",
              "Veli İletişimi: Deneme sınavı sonuçlarına verilen abartılı tepkiler törpülenmelidir.",
              "PDR Odak: 'Yapamayacağım' şeklindeki otomatik olumsuz düşüncelere karşı öz şefkat aşılanmalıdır."
          ]
      };
  } else {
      // Çalışma Alışkanlıkları ve Motivasyon (veya Genel)
      interventionObj = {
          title: "Stratejik Akademik Koçluk",
          icon: Compass, color: "text-orange-700", bg: "bg-orange-50 print:bg-white border-orange-200 print:border-slate-300",
          desc: "Temel sorun masaya oturma direnci, erteleme davranışı (procrastination) veya yanlış çalışma taktikleridir.",
          bullets: [
              "Öğrencilere 'Verimli Ders Çalışma ve Zaman Yönetimi' atölyeleri düzenlenmelidir.",
              "Devasa hedefler yerine, günlük 'Küçük Adımlar / Mikro Hedefler' belirleme becerisi kazandırılmalıdır.",
              "İçsel motivasyonu tetikleyecek 'Kariyer ve Meslek Tanıtım' günleri planlanmalıdır."
          ]
      };
      stakeholderObj = {
          title: "Takip ve Sınır Koyma",
          icon: CheckCircle, color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",
          desc: "Öğrencilerin kendi kendilerini yönetme becerileri (öz-denetim) zayıf olduğu için dışsal destek gerekir.",
          bullets: [
              "Öğretmenler: Sadece ödev vermek yerine, ödevin nasıl yapılacağına dair strateji de sunmalıdır.",
              "Veli İletişimi: Evde teknoloji kullanımına sınır getirilmesi ve çalışma rutinleri oluşturulması sağlanmalıdır.",
              "PDR Odak: Öğrenciyle haftalık takip çizelgeleri (check-list) üzerinden net kontroller yapılmalıdır."
          ]
      };
  }

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('basarisizlik-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="basarisizlik-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - AKADEMİK YÖNETİCİ ÖZETİ           */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          {/* 1. ÜST BAŞLIK */}
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Activity className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   BAŞARISIZLIK NEDENLERİ • KURUMSAL RİSK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          {/* 2. 3'LÜ KPI KARTLARI */}
          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-emerald-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-emerald-600'}`}>Akademik Tükenmişlik</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-emerald-700'}`}>
                 {data.redAlarmStudents} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{redAlarmPercent})</span>
              </p>
            </div>
            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Baskın Atıf Yönü</span>
              </div>
              <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight truncate">
                {data.internalPercent > data.externalPercent ? 'İçsel Sorumluluk' : 'Dışsal Suçlama'}
              </p>
            </div>
            <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Activity className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>
                 <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">Ortalama Risk Yükü</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">
                 {data.avgRisksPerStudent} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Sorun/Kişi</span>
              </p>
            </div>
          </div>

          {/* 3. MASONRY GRID (GİYOTİN HATASI İÇİN YENİDEN TASARLANDI) */}
          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 mt-1 print:mt-0">
            
            {/* KART 1: KARE - EN RİSKLİ ŞUBELER RADARI */}
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px] avoid-break">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Akademik Kırılganlık
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                 <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Grup</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">({data.classStats[0].riskScore} Yük/Kişi)</span>}
                    </p>
                 </div>
                 <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Grup</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'Diğer Gruplar Normal'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">({data.classStats[1].riskScore} Yük/Kişi)</span>}
                    </p>
                 </div>
               </div>
            </div>

            {/* KART 2: KARE - KURUMSAL KONTROL ODAĞI */}
            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px] avoid-break">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Scale className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Kontrol Odağı (Atıf)
               </h3>
               <div className="flex items-center justify-between mb-1.5 mt-1">
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">İÇSEL</span>
                       <span className="text-base print:text-[11px] font-black text-indigo-700">%{data.internalPercent}</span>
                   </div>
                   <div className="flex-1 px-3 print:px-2 flex items-center">
                       <div className="h-2.5 print:h-1.5 flex-1 bg-indigo-500 rounded-l-full print:bg-slate-700"></div>
                       <div className="h-2.5 print:h-1.5 flex-1 bg-rose-400 rounded-r-full print:bg-slate-300"></div>
                   </div>
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">DIŞSAL</span>
                       <span className="text-base print:text-[11px] font-black text-rose-700">%{data.externalPercent}</span>
                   </div>
               </div>
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-1 text-justify line-clamp-3">
                 {locusText}
               </p>
            </div>

            {/* KART 3: YATAY - EN SIK İŞARETLENEN İLK 10 SPESİFİK MADDE */}
            <div className="col-span-2 bg-amber-50 p-4 print:p-3.5 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex flex-col justify-center avoid-break">
               <div className="flex justify-between items-center border-b border-amber-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-amber-900 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <AlertTriangle className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-amber-600"/> Nokta Atışı: En Sık Görülen 10 Engel
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-amber-700 print:text-slate-500 italic">Öğrenci Katılım Oranı</span>
               </div>
               
               <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-x-6 gap-y-2 print:gap-x-4 print:gap-y-1 mt-1">
                 {data.top10Items.length > 0 ? data.top10Items.map((item, idx) => (
                   <div key={idx} className="flex justify-between items-center bg-white print:bg-amber-50/30 px-3 py-2 print:px-2 print:py-1 rounded-lg border border-amber-100 print:border-amber-200 shadow-sm print:shadow-none">
                     <div className="flex items-center flex-1 overflow-hidden pr-3 print:pr-1">
                        <span className="text-amber-500 mr-2 font-black text-xs print:text-[9px]">{(idx + 1)}.</span> 
                        <span className="text-[11px] print:text-[8.5px] font-bold text-slate-800 leading-tight truncate" title={item.text}>{item.text}</span>
                     </div>
                     <span className="text-xs print:text-[9px] font-black text-amber-600 shrink-0">%{item.percent}</span>
                   </div>
                 )) : (
                   <p className="text-xs text-slate-500 italic col-span-2 text-center">Yeterli veri yok.</p>
                 )}
               </div>
            </div>

            {/* KART 4: YATAY - ANA PROBLEM ALANLARI */}
            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none avoid-break">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <PieChartIcon className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Okulu Aşağı Çeken Akademik Bariyerler
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Genel Risk Dağılımı</span>
               </div>
               
               <div className="space-y-3 print:space-y-2 mt-2">
                  {data.topCategories.slice(0, 4).map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent} <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">({dim.count} Madde)</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className="h-full rounded-full bg-slate-600 print:bg-slate-500" style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>
          
          </div>

          {/* 4. YENİ BÖLÜM: 1. SAYFAYI TAM DOLDURAN 2 BÜYÜK KARE KART */}
          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             {/* YENİ KART 1: PDR MÜDAHALE ODAĞI */}
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${interventionObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <interventionObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${interventionObj.color}`}/>
                  Kurumsal Müdahale Odağı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${interventionObj.color}`}>
                      {interventionObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {interventionObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {interventionObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${interventionObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             {/* YENİ KART 2: PAYDAŞ EYLEM PLANI */}
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${stakeholderObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <stakeholderObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${stakeholderObj.color}`}/>
                  Paydaş Eylem Planı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${stakeholderObj.color}`}>
                      {stakeholderObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {stakeholderObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {stakeholderObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${stakeholderObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        {/* ZORUNLU SAYFA KESMESİ: YAPAY ZEKA KESİNLİKLE 2. SAYFAYA ATILIR */}
        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          {/* YAPAY ZEKA STRATEJİ MOTORU */}
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Akademik Gelişim Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.topCategories)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
    <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
    <EditableAIBox text={aiResult} />
</div>
)}
          </div>

         {/* YAZDIRMA İÇİN İMZA ALANI (Giyotin Hatası Giderildi) */}
          <div className="hidden print:flex justify-between mt-8 pt-6 text-[12px] text-black px-12 border-t border-slate-300 avoid-break print:break-inside-avoid">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-12">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-12">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};